import type { RuleExpression } from 'vee-validate';
import { computed, ref, watch } from 'vue';

export interface InputProps<T = string> {
  modelValue?: T;
  defaultValue?: T;
  disabled?: boolean;
  readonly?: boolean;
  required?: boolean;
  name: string;
  id: string;
  rules?: RuleExpression<unknown>;
}

export function useInput<T = string>(
  props: InputProps<T>,
  emit: (
    event: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...args: any[]
  ) => void
) {
  const internalValue = ref<T | undefined>(props.defaultValue);

  const currentValue = computed({
    get: () =>
      props.modelValue !== undefined ? props.modelValue : internalValue.value,
    set: (val: T | undefined) => {
      if (props.modelValue !== undefined) {
        emit('update:modelValue', val);
      } else {
        internalValue.value = val;
      }
    },
  });

  watch(
    () => props.modelValue,
    val => {
      if (val !== undefined) internalValue.value = val;
    }
  );

  return { currentValue };
}
